export const Types = {
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
};
